import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df6d8ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "person-id" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Person id", -1))

import { nextTick, ref } from 'vue'
import Modal from '@/util/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewCardModal',
  emits: ["add"],
  setup(__props, { expose: __expose, emit }) {



// The parent drives the modal (open/close/reset) and does the FS read + addCardInfo,
// so it stays busy while the parent works and can reopen on failure.
__expose({
  open: () => modalRef.value?.open(),
  close: () => modalRef.value?.close(),
  reset: () => modalRef.value?.reset(),
})

const personIdRef = ref('')

const modalRef = ref<InstanceType<typeof Modal>>()
const inputRef = ref<HTMLInputElement>()

async function onShown() {
  personIdRef.value = ''
  await nextTick()
  inputRef.value?.focus()
}

function onOk() {
  emit('add', personIdRef.value.trim())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    small: "",
    "ok-text": "Add card",
    "ok-disabled": !personIdRef.value.trim(),
    "busy-text": "Adding…",
    onShown: onShown,
    onOk: onOk
  }, {
    title: _withCtx(() => [
      _createTextVNode("New card")
    ]),
    default: _withCtx(() => [
      _createElementVNode("label", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          ref_key: "inputRef",
          ref: inputRef,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((personIdRef).value = $event)),
          placeholder: "e.g. K26X-V71",
          autocomplete: "off",
          spellcheck: "false"
        }, null, 512), [
          [
            _vModelText,
            personIdRef.value,
            void 0,
            { trim: true }
          ]
        ])
      ])
    ]),
    _: 1
  }, 8, ["ok-disabled"]))
}
}

})